import React from 'react'

export const ThreadListSkeleton: React.FC = () => (
  <div className="w-80 md:w-64 lg:w-80 h-full flex flex-col box-border bg-gray-50 dark:bg-muted/30 border-r border-gray-200 dark:border-border overflow-hidden">
    <div className="relative bg-white dark:bg-background flex-shrink-0 border-b border-gray-200 dark:border-border">
      <div className="h-16 px-4 flex items-center gap-2">
        <div className="h-9 flex-1 bg-gray-200 dark:bg-muted rounded-md animate-pulse" />
        <div className="h-9 w-9 bg-gray-200 dark:bg-muted rounded-md animate-pulse" />
      </div>
    </div>
    <div className="flex-1 overflow-y-auto overflow-x-hidden">
      {Array.from({ length: 6 }, (_, index) => (
        <div
          key={index}
          className="px-5 py-3 border-b border-gray-200 dark:border-border flex items-start gap-3"
        >
          <div className="w-10 h-10 bg-gray-200 dark:bg-muted rounded-full animate-pulse flex-shrink-0"></div>
          <div className="flex-1 min-w-0 flex flex-col gap-1">
            <div className="w-3/4 h-4 bg-gray-200 dark:bg-muted rounded animate-pulse"></div>
            <div className="w-full h-3 bg-gray-100 dark:bg-muted/60 rounded animate-pulse"></div>
            <div className="w-1/2 h-3 bg-gray-100 dark:bg-muted/60 rounded animate-pulse"></div>
          </div>
          <div className="flex flex-col items-end gap-1 flex-shrink-0">
            <div className="w-12 h-3 bg-gray-200 dark:bg-muted rounded animate-pulse"></div>
            <div className="w-8 h-3 bg-gray-100 dark:bg-muted/60 rounded animate-pulse"></div>
          </div>
        </div>
      ))}
    </div>
  </div>
)
